import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText, StyleSiteName } from '../style'

const SiteEditConfirmation = ({ toggleModal, proposeEditSite, name }) => {
  const closeModal = () => {
    toggleModal(false)
  }
  return (
    <div>
      <ValidationProposalModalText>
        Are you sure that you want to submit the changes made to <StyleSiteName>{name}</StyleSiteName>? This action cannot be undone and your edits will be submitted for approval.
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="primary" onClick={() => {
          proposeEditSite()
          closeModal()
        }}>
          <FormattedMessage id="submit" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default SiteEditConfirmation

SiteEditConfirmation.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  proposeEditSite: PropTypes.func.isRequired,
  name: PropTypes.string
}
